module.exports = __webpack_public_path__ + "img/gb.04d05328.svg";